import { Box, Pagination, Typography, styled } from '@mui/material';
import React from 'react';
import { translate } from '../../helper';

const PaginationWrapper = styled(Pagination)(({ theme }) => ({
    'display': 'flex',
    'justifyContent': 'end',
    'margin': 'var(--sp-lg) 0',
    fontSize: 'var(--fs-md)',
    '& .MuiPaginationItem-root': {
        'fontSize': 'var(--fs-md)',
        height:' calc(var(--fs-xs)*3.2)',
        width: 'calc(var(--fs-xs)*3.2)',
        padding:'0 var(--sp-sm)'
    },
    '& .MuiSvgIcon-root': {
        height: 'var(--fs-xl)',
        width: 'var(--fs-xl)'
    },

    '& .Mui-selected': {
        'color': '#1890ff !important',
        'border': '1px solid #1890ff !important',
        'background': 'white !important'
    }
}));

const usePagination = (total, filters, setFilters, disabled = false) => {

    const handleChangePage = (evt, newPage) => {
        if (disabled) return
        setFilters({
            ...filters,
            pageNo: newPage
        });
    };

    return (
        [
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {
                    total > 0 && (
                        <>
                            <Typography variant='body1' sx={{ margin: 'var(--sp-lg) 0', fontSize: 'calc(var(--fs-xs)*1.578947)', fontWeight:400 }}>{translate('showing')} <b>{(filters.pageNo - 1) * filters.limit + 1}</b> {translate('to')} <b>{Math.min(filters.pageNo * filters.limit, total)}</b> {translate('of')} <b>{total}</b> {translate('results')}</Typography>
                            <PaginationWrapper
                                variant="outlined"
                                shape="rounded"
                                component="div"
                                count={Math.ceil(total / filters.limit)}
                                onChange={handleChangePage}
                                page={filters.pageNo}
                                sx={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}
                                aria-disabled={disabled}
                            />
                        </>
                    )
                }

            </Box>
        ]
    );

}

export default usePagination;